import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import Axios from 'axios'
import VueScrollTo from 'vue-scrollto'
import ReadMore from 'vue-read-more'
import ActionCableVue from 'actioncable-vue'

import router from './router'
import store from './store'
import i18n from './i18n'

// Files imports
import '@mdi/font/css/materialdesignicons.css'
// import 'buefy/dist/buefy.css'
import '@/assets/css/main.scss'
import 'vue-it-bigger/dist/vue-it-bigger.min.css'
import './vee-validate'
// Instantiate token in header
Vue.prototype.$http = Axios
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

// Usages
Vue.use(ActionCableVue, {
  connectImmediately: false,
  store: store
})
Vue.use(Buefy)
Vue.use(VueScrollTo)
Vue.use(ReadMore)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
